import React, { useState, useEffect, useRef } from "react";
import { Button, Modal, Form, Table, InputGroup } from "react-bootstrap";
import { FaEdit, FaTrashAlt, FaEye } from "react-icons/fa";
import { RiShareBoxFill } from "react-icons/ri";
import {
  deleteAdApiById,
  fetchAdApis,
  restoreAdApi,
  searchAdApi,
  toggleAdApiStatus,
} from "../../services/axios/apiManager";
import AddAdApiModal from "./addAdAPIModal";
import BSPagination from "../../Components/pagination";
import LoadingSpinner from "../../Components/spinner";
import { toast } from "sonner";
import { handleErrors } from "../../services/dataManager";
import { useNavigate } from "react-router-dom";
import AdApiDetailsModal from "./adApiDetailsModal";
import { TbRestore } from "react-icons/tb";

const AdsApisList = ({
  adsApis,
  setAdsApis,
  pagination,
  setPagination,
  granted,
}) => {
  const navigate = useNavigate();
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [modalOptions, setModalOptions] = useState({});
  const [query, setQuery] = useState("");
  const [selectedAdApi, setSelectedAdApi] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filters, setFilters] = useState("3");
  const [filtering, setFiltering] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedID, setSelectedID] = useState("");

  // // // fetch Ads Api
  const fetchAdsApis = async (pgntn, str = "") => {
    setFiltering(true);
    const res = await fetchAdApis(pgntn.currentPage, pgntn.pageSize, str);
    if (res?.data?.success && res?.data?.data) {
      if (res?.data?.pagination) {
        console.log("res?.data?.pagination :", res?.data?.pagination);
        setPagination(res.data.pagination);
      }
      setAdsApis(res.data.data);
    } else {
      handleErrors(res, navigate);
    }
    setFiltering(false);
  };

  // // // handle page change
  const handlePageChange = async (page) => {
    const temp = { ...pagination, currentPage: page };
    setPagination(temp);
    const str = `status=${filters}`;
    await fetchAdsApis(temp, str);
  };

  // // // Reset all filters to default
  const resetFilters = async () => {
    setFilters(3);
    setQuery("");
    await fetchAdsApis(pagination);
  };

  // // // Search Logic
  const handleSearch = async (e) => {
    const string = e.target.value;
    setQuery(string);
    if (string.length > 0) {
      setFiltering(true);
      setFilters(3);
      const results = await searchAdApi(string);
      if (results?.data?.data) {
        setAdsApis(results.data.data);
      }
      setFiltering(false);
    } else {
      await fetchAdsApis(pagination);
    }
  };

  // // // Filters Logic
  // // // status = 0-Inactive, 1-Active, 2-deleted, 3 default
  const fetchFilteredAdsApis = async (e) => {
    setQuery("");
    setFilters(e.target.value);
    const string = `status=${e.target.value}`;
    await fetchAdsApis(pagination, string);
  };

  // // // Open Status Modal Logic
  const handleStatusChange = async (adApi) => {
    if (!granted?.some((g) => g.type === "toggle-status")) {
      toast.error(
        "You don't have neccessary permissions to do this operation!",
        {
          duration: 3000,
        }
      );
      return;
    }
    if (adApi.deletedAt === null) {
      setModalOptions({
        header: "Change Status",
        body: `Are you sure you want to change the status of "${adApi.name}"?`,
        okay: "Change",
        method: changeStatus,
        data: { id: adApi.id, status: adApi.status === 1 ? 0 : 1 },
      });
      setShowOptionsModal(true);
    } else {
      toast.info("Cannot change status of a deleted record!", {
        duration: 2000,
      });
    }
  };

  // // // Status Change Logic
  const changeStatus = async (data) => {
    const response = await toggleAdApiStatus(data);
    if (response?.data?.success === true) {
      const str = `status=${filters}`;
      await fetchAdsApis(pagination, str);
    }
    setModalOptions({});
    setShowOptionsModal(false);
  };

  // // // Delete Modal Logic
  const handleDeleteAdApi = (adApi) => {
    setModalOptions({
      header: "Delete Ad-Api",
      body: `Are you sure you want to delete "${adApi.ads_API}"?`,
      okay: "Delete",
      method: deleteAdApi,
      data: { id: adApi.id },
    });
    setShowOptionsModal(true);
  };

  // // //Delete Lodic
  const deleteAdApi = async (data) => {
    if (data.id) {
      const response = await deleteAdApiById(data.id);
      if (response?.data?.success && response?.data?.data === 1) {
        const str = `status=${filters}`;
        await fetchAdsApis(pagination, str);
        toast.info("Ad-Api record has been deleted!", {
          duration: 2000,
        });
        setModalOptions({});
        setShowOptionsModal(false);
      } else {
        setModalOptions({});
        setShowOptionsModal(false);
      }
    }
  };

  // // // Restore Modal Logic
  const handleRestoreAdApi = (adApi) => {
    setModalOptions({
      header: "Restore Ad Api",
      body: `Are you sure you want to restore "${adApi.ads_API}"?`,
      okay: "Restore",
      method: RestoreAdApiById,
      data: { id: adApi.id },
    });
    setShowOptionsModal(true);
  };

  // // //Restore Lodic
  const RestoreAdApiById = async (data) => {
    if (data.id) {
      const response = await restoreAdApi(data.id);
      if (response?.data?.success) {
        const str = `status=${filters}`;
        await fetchAdsApis(pagination, str);
        toast.info("Ad-Api record has been restored!", {
          duration: 2000,
        });
        setModalOptions({});
        setShowOptionsModal(false);
      } else {
        setModalOptions({});
        setShowOptionsModal(false);
      }
    }
  };

  // // // Open options Prmopt Modal
  const handleCloseOptionsModal = () => {
    setModalOptions({});
    setShowOptionsModal(false);
  };

  // // // Open Add/Edit Modal
  const handleShowModal = (adApi) => {
    setSelectedAdApi(adApi);
    setShowModal(true);
  };
  // // // Close Add/Edit Modal
  const handleHideModal = () => {
    setShowModal(false);
    setSelectedAdApi({});
  };

  const handleShowDetails = async (id) => {
    setSelectedID(id);
    setShowDetailsModal(true);
  };

  return (
    <div className="container py-4 text-light bg-dark p-3 rounded mb-4">
      <div className="row align-items-center mb-2">
        <div className="col-md-8 row">
          <div className="col-md-5">
            <Form.Control
              type="text"
              placeholder="Search Ad Apis..."
              value={query}
              onChange={(e) => {
                handleSearch(e);
              }}
              className="bg-dark text-light border-light input-placeholder-light"
            />
          </div>
          <div className="col-md-5">
            <InputGroup className="mb-3">
              <Form.Select
                type="text"
                placeholder="Search FAQs by category..."
                value={filters}
                onChange={(e) => {
                  fetchFilteredAdsApis(e);
                }}
                className="bg-dark text-light border-light input-placeholder-light"
              >
                <option value="3">Active & Inactive</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
                <option className="text-danger" value="2">
                  Deleted
                </option>
              </Form.Select>
            </InputGroup>
          </div>
          <div className="col-md-1">
            {filtering ? (
              <LoadingSpinner size={"md"} />
            ) : (
              <div className="row ">
                <Button
                  title="Reset Filters And Rrfresh Records"
                  className="btn btn-success"
                  onClick={() => {
                    resetFilters();
                  }}
                >
                  Reset
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className="col-md-4 text-end">
          {granted?.some((g) => g.type === "create") && (
            <Button
              title="Add New Ad-API"
              variant="success"
              className="mb-3 d-flex"
              onClick={() => handleShowModal({})}
              style={{ float: "right" }}
            >
              Add New
            </Button>
          )}
        </div>
      </div>

      {adsApis?.length > 0 ? (
        <div className="table-responsive mt-2">
          <Table className="table-hover table-striped align-middle table-borderless table-dark">
            <thead>
              <tr>
                <th>Name</th>
                <th>Ad Units</th>
                <th>Ad-Units Details</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {adsApis.map((adApi) => (
                <tr key={adApi?.id}>
                  <td>{adApi?.name}</td>
                  <td>{adApi?.total_ad_units || 0}</td>
                  <td>
                    <button
                      className="btn btn-link d-flex align-items-center text-primary"
                      style={{ textDecoration: "none" }}
                      onClick={() => {
                        navigate(`/AdsApi/Ad-Unit/${adApi?.id}`);
                      }}
                    >
                      View Ad-Units
                      <RiShareBoxFill className="mx-1" />
                    </button>
                  </td>
                  <td>
                    <button
                      className={`btn btn-link p-0 m-0 border-0 ${
                        adApi?.status ? "text-success" : "text-danger"
                      }`}
                      onClick={() => {
                        handleStatusChange(adApi);
                      }}
                      style={{ textDecoration: "none" }}
                      title="change status"
                    >
                      {adApi?.status === 1 ? "Active" : "Inactive"}
                    </button>
                  </td>
                  {adApi?.deletedAt ? (
                    <td>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => {
                          handleRestoreAdApi(adApi);
                        }}
                        title="delete"
                      >
                        <TbRestore />
                      </Button>
                    </td>
                  ) : (
                    <td>
                      <Button
                        variant="outline-success"
                        size="sm"
                        onClick={() => {
                          handleShowDetails(adApi?.id);
                        }}
                        title="view details"
                      >
                        <FaEye />
                      </Button>
                      <Button
                        variant="outline-primary"
                        className="mx-1"
                        size="sm"
                        onClick={() => {
                          handleShowModal(adApi);
                        }}
                        title="edit"
                      >
                        <FaEdit />
                      </Button>
                      {adApi?.status === 0 && (
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => {
                            handleDeleteAdApi(adApi);
                          }}
                          title="delete"
                        >
                          <FaTrashAlt />
                        </Button>
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>

          <div className="d-flex justify-content-end mt-2">
            <div className="mx-4 py-2">
              <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
            </div>
            <BSPagination
              currentPage={pagination.currentPage}
              totalPages={pagination.totalPages}
              onPageChange={handlePageChange}
              siblingCount={2}
              showFirstLast
            />
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-center mt-10">
          <span className="text-light">No Ads-APIs data found!</span>
        </div>
      )}
      {/* /////////////////////////Add/Edit Modal////////////////// */}
      <AddAdApiModal
        selectedAdApi={selectedAdApi}
        setSelectedAdApi={setSelectedAdApi}
        showModal={showModal}
        handleHideModal={handleHideModal}
        setAdsApis={setAdsApis}
      />
      {/* /////////////////////////Add/Edit Modal////////////////// */}
      <AdApiDetailsModal
        showDetailsModal={showDetailsModal}
        setShowDetailsModal={setShowDetailsModal}
        id={selectedID}
      />
      <Modal
        show={showOptionsModal}
        onHide={handleCloseOptionsModal}
        centered
        className="text-light"
      >
        <Modal.Header closeButton className="bg-dark text-light border-0">
          <Modal.Title>{modalOptions.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          {modalOptions.body}
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light border-0">
          <Button variant="secondary" onClick={handleCloseOptionsModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              modalOptions.method(modalOptions.data);
            }}
          >
            {modalOptions.okay}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default AdsApisList;
